import i18next from 'i18next'
import React, { useState } from 'react'
import { isDesktop } from 'react-device-detect'
import { useTranslation } from 'react-i18next'

import { ReactComponent as Arrow } from 'assets/landing-images/arrow-down.svg'
import { ReactComponent as DiscordIcon } from 'assets/landing-images/socials/discord.svg'
import { ReactComponent as EmailIcon } from 'assets/landing-images/socials/email.svg'
import { ReactComponent as MediumIcon } from 'assets/landing-images/socials/medium.svg'
import { ReactComponent as TelegramIcon } from 'assets/landing-images/socials/telegram.svg'
import { ReactComponent as TwitterIcon } from 'assets/landing-images/socials/twitter.svg'
import logo from 'assets/svg/logo-white.svg'

import * as S from './styleds'

const socials = [
  {
    name: 'email',
    Icon: EmailIcon,
    url: 'mailto:info@wowswap.io'
  },
  {
    name: 'telegram',
    Icon: TelegramIcon,
    url: 'https://t.me/wowswap'
  },
  {
    name: 'twitter',
    Icon: TwitterIcon,
    url: 'https://twitter.com/Wowswap_io'
  },
  {
    name: 'discord',
    Icon: DiscordIcon,
    url: 'https://discord.com/invite/H4Z4fVNnFF'
  },
  {
    name: 'medium',
    Icon: MediumIcon,
    url: 'https://wowswap-io.medium.com/'
  }
]

const t = i18next.t.bind(i18next)

const navigation = [
  {
    title: t('Company'),
    items: [
      { name: t('Trade'), url: '/swap' },
      { name: t('Earn'), url: '/earn' },
      { name: t('WOWswap PRO'), url: '/pro', visible: isDesktop }
      // { name: t('Careers'), url: '' }
    ]
  },
  {
    title: t('Documentation'),
    items: [
      // { name: t('Terms of use'), url: '' },
      // { name: t('Privacy policy'), url: '' },
      {
        name: t('Media kit'),
        url: 'https://drive.google.com/drive/folders/1apOW082SKDuo5j5of60JmpVNSlHyjG3q?usp=sharing',
        targetBlank: true
      },
      {
        name: t('Audit Report'),
        url: 'https://hacken.io/wp-content/uploads/2021/06/WowSwap_03062021SCAudit_Report_2.pdf',
        targetBlank: true
      },
      { name: t('GitHub'), url: 'https://github.com/wowswap-io', targetBlank: true }
    ]
  },
  {
    title: t('Knowledge base'),
    items: [
      { name: t('FAQ'), url: 'https://docs.wowswap.io/faq', targetBlank: true },
      {
        name: t('Stop Loss and Take Profit'),
        url: 'https://docs.wowswap.io/howtoguide/set-stop-loss-and-take-profit-orders',
        targetBlank: true
      },
      {
        name: t('Opening and Closing Position'),
        url: 'https://docs.wowswap.io/howtoguide/opening-and-closing-a-leveraged-position',
        targetBlank: true
      }
      // { name: t('WOWswap PRO'), url: '', targetBlank: true }
    ]
  }
]

type Item = { name: string; url: string; targetBlank?: boolean; visible?: boolean }

export const Footer = () => {
  const [openNav, setOpenNav] = useState<string | null>(null)

  const { t } = useTranslation()

  const toggleNav = (navTitle: string) => {
    if (navTitle === openNav) {
      setOpenNav(null)
    } else {
      setOpenNav(navTitle)
    }
  }

  return (
    <S.FooterStyled>
      <S.Logo src={logo} alt={t('WOWswap-Logo')} />
      <S.Info>
        <S.Socials>
          {socials.map(({ name, Icon, url }) => (
            <S.Social key={name} data-social={name} href={url} target="_blank" rel="noreferrer">
              <Icon />
            </S.Social>
          ))}
        </S.Socials>
        <S.EmailLabel>{t('E-mail')}:</S.EmailLabel>
        <S.Email>info@wowswap.io</S.Email>
        {/* <S.EmailLabel>{t('Support E-mail')}:</S.EmailLabel>
        <S.Email>wowswap@support</S.Email>
        <S.EmailLabel>{t('Commercial E-mail')}:</S.EmailLabel>
        <S.Email>wowswap@commercial</S.Email> */}
      </S.Info>
      <S.Nav>
        {navigation.map(({ title, items }: { title: string; items: Item[] }) => (
          <S.NavList key={title} isOpen={openNav === title}>
            <S.NavTitle onClick={() => toggleNav(title)} isOpen={openNav === title}>
              {title}
              <Arrow />
            </S.NavTitle>
            {items
              .filter(({ visible }) => (visible !== undefined ? visible : true))
              .map(({ name, url, targetBlank }) => (
                <S.NavItem key={name}>
                  <S.NavLink to={{ pathname: url }} target={targetBlank ? '_blank' : undefined}>
                    {name}
                  </S.NavLink>
                </S.NavItem>
              ))}
          </S.NavList>
        ))}
      </S.Nav>
      <S.Copyright>
        © {t('Copyright WowSwap')} {new Date().getFullYear()}
      </S.Copyright>
    </S.FooterStyled>
  )
}
